// @flow

import type { Thumbnail } from './OfferProfile.types'

export const getThumbnails = (
  thumbnails: Array<Thumbnail>
): Array<{ [String]: string }> => {
  return thumbnails.map(item => ({ [item.size[0].toString()]: item.url }))
}
